import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rd-grid rd-gap-2 rd-w-full project-selection"
}
const _hoisted_2 = { class: "rd-relative" }
const _hoisted_3 = {
  key: 0,
  class: "border-input-focus"
}
const _hoisted_4 = {
  key: 1,
  class: "form-field-container rd-w-full"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "fa-solid fa-check rd-me-1",
  "aria-hidden": "true"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "fa-solid fa-check rd-me-1",
  "aria-hidden": "true"
}
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_GiftArrayComponent = _resolveComponent("GiftArrayComponent")!
  const _component_ProjectCardComponent = _resolveComponent("ProjectCardComponent")!

  return (_ctx.renderStore.builderMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[6] || (_cache[6] = [
        _createElementVNode("button", {
          class: "rd-btn rd-btn-primary rd-mb-2",
          type: "button"
        }, "Project Selection", -1)
      ])))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.showDropdown)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: _normalizeClass(["project-dropdown-container", _ctx.dropdownWrapperClass])
            }, [
              (_ctx.fieldStyle != _ctx.FieldStyle.Default)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["form-field-container", [{ 'form-underline': _ctx.fieldStyle == _ctx.FieldStyle.Underline },
                    { 'form-compact form-compact-full rd-w-full': _ctx.fieldStyle == _ctx.FieldStyle.Compact }]])
                  }, [
                    _createElementVNode("label", {
                      for: "selectedProjects",
                      class: _normalizeClass({ 'rd-sr-only': !_ctx.hasLabel })
                    }, _toDisplayString(_ctx.getLabel), 3),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_VueMultiselect, {
                        id: "selectedProjects",
                        modelValue: _ctx.selectedProjects,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProjects) = $event)),
                        "track-by": "value",
                        label: "text",
                        "select-label": "",
                        "selected-label": "",
                        "deselect-label": "",
                        class: _normalizeClass(["select-project multiselect-element", [{ 'multiselect-underline': _ctx.fieldStyle == _ctx.FieldStyle.Underline },
                                { 'multiselect-compact': _ctx.fieldStyle == _ctx.FieldStyle.Compact }]]),
                        multiple: _ctx.projectSettings.allowMultipleProjects,
                        "close-on-select": !_ctx.projectSettings.allowMultipleProjects,
                        placeholder: _ctx.getPlaceholder,
                        options: _ctx.dropdownProjects,
                        loading: _ctx.projectsLoading,
                        searchable: true,
                        "internal-search": false,
                        "allow-empty": true,
                        onSearchChange: _ctx.searchProjects,
                        onSelect: _ctx.selectProject,
                        onRemove: _ctx.removeSelect,
                        onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDropdownWrapperClass('open'))),
                        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDropdownWrapperClass('close'))),
                        "aria-autocomplete": "list",
                        "aria-expanded": _ctx.isProjectsOpen,
                        "aria-controls": "listbox-selectedProjects",
                        "aria-label": "Select from dropdown list"
                      }, null, 8, ["modelValue", "class", "multiple", "close-on-select", "placeholder", "options", "loading", "onSearchChange", "onSelect", "onRemove", "aria-expanded"]),
                      (_ctx.fieldStyle == _ctx.FieldStyle.Underline)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("label", {
                      for: "selectedProjects",
                      class: _normalizeClass({ 'rd-sr-only': !_ctx.hasLabel })
                    }, _toDisplayString(_ctx.getLabel), 3),
                    _createVNode(_component_VueMultiselect, {
                      id: "selectedProjects",
                      modelValue: _ctx.selectedProjects,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedProjects) = $event)),
                      "track-by": "value",
                      label: "text",
                      "select-label": "",
                      "selected-label": "",
                      "deselect-label": "",
                      class: "select-project multiselect-element",
                      multiple: _ctx.projectSettings.allowMultipleProjects,
                      "close-on-select": !_ctx.projectSettings.allowMultipleProjects,
                      placeholder: _ctx.getPlaceholder,
                      options: _ctx.dropdownProjects,
                      loading: _ctx.projectsLoading,
                      searchable: true,
                      "internal-search": false,
                      "allow-empty": true,
                      onSearchChange: _ctx.searchProjects,
                      onSelect: _ctx.selectProject,
                      onRemove: _ctx.removeSelect,
                      onOpen: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDropdownWrapperClass('open'))),
                      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setDropdownWrapperClass('close'))),
                      "aria-autocomplete": "list",
                      "aria-expanded": _ctx.isProjectsOpen,
                      "aria-controls": "listbox-selectedProjects",
                      "aria-label": "Select from dropdown list"
                    }, null, 8, ["modelValue", "multiple", "close-on-select", "placeholder", "options", "loading", "onSearchChange", "onSelect", "onRemove", "aria-expanded"])
                  ]))
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("section", {
          class: _normalizeClass(["projects-container", { 'chosen-projects': _ctx.showDropdown }])
        }, [
          (_ctx.allowsMultipleProjects && _ctx.cardProjects.length >= 1 || _ctx.cardProjects.length > 1)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardProjects, (project) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: project.value,
                    class: "project"
                  }, [
                    _createVNode(_component_ProjectCardComponent, {
                      id: project.value,
                      showImage: _ctx.projectSettings.showImage,
                      showDescription: _ctx.projectSettings.showDescription,
                      onRemoveProject: _ctx.removeProject
                    }, {
                      projectGiftArray: _withCtx(() => [
                        (_ctx.showProjectGiftArray)
                          ? (_openBlock(), _createBlock(_component_GiftArrayComponent, {
                              key: 0,
                              component: _ctx.component,
                              projectId: project.value,
                              projectName: project.text,
                              useSmartGiftArray: _ctx.useSmartGiftArray,
                              hasGiftArray: _ctx.projectSettings.showGiftArray,
                              hasCustomAmount: _ctx.projectSettings.showCustomAmount,
                              customAmountLabel: `Donation amount for ${project.text}`
                            }, null, 8, ["component", "projectId", "projectName", "useSmartGiftArray", "hasGiftArray", "hasCustomAmount", "customAmountLabel"]))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: _normalizeClass(["rd-btn rd-btn-primary rd-btn-select", { active: _ctx.renderStore.isProjectActive(project.value) }]),
                              onClick: _withModifiers(($event: any) => (_ctx.selectProject(project)), ["stop"])
                            }, [
                              (_ctx.renderStore.isProjectActive(project.value))
                                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                                : _createCommentVNode("", true),
                              (_ctx.renderStore.isProjectActive(project.value))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[7] || (_cache[7] = _createTextVNode(" Selected ")),
                                    (_ctx.isFixedAmount)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "($" + _toDisplayString(_ctx.component.customData.fixedAmount) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(" Select ")
                                  ], 64))
                            ], 10, _hoisted_6))
                      ]),
                      _: 2
                    }, 1032, ["id", "showImage", "showDescription", "onRemoveProject"])
                  ]))
                }), 128))
              ]))
            : (!_ctx.allowsMultipleProjects && _ctx.cardProjects.length === 1)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cardProjects, (project) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: project.value,
                    class: "project single-project rd-flex rd-mt-3.5"
                  }, [
                    _createVNode(_component_ProjectCardComponent, {
                      id: project.value,
                      showImage: _ctx.projectSettings.showImage,
                      showDescription: _ctx.projectSettings.showDescription,
                      onRemoveProject: _ctx.removeProject
                    }, {
                      projectGiftArray: _withCtx(() => [
                        (_ctx.showProjectGiftArray)
                          ? (_openBlock(), _createBlock(_component_GiftArrayComponent, {
                              key: 0,
                              component: _ctx.component,
                              projectId: project.value,
                              projectName: project.text,
                              useSmartGiftArray: _ctx.useSmartGiftArray,
                              hasGiftArray: _ctx.projectSettings.showGiftArray,
                              hasCustomAmount: _ctx.projectSettings.showCustomAmount
                            }, null, 8, ["component", "projectId", "projectName", "useSmartGiftArray", "hasGiftArray", "hasCustomAmount"]))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: _normalizeClass(["rd-btn rd-btn-primary rd-btn-select", { active: _ctx.renderStore.isProjectActive(project.value) }]),
                              onClick: _withModifiers(($event: any) => (_ctx.selectProject(project)), ["stop"])
                            }, [
                              (_ctx.renderStore.isProjectActive(project.value))
                                ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                                : _createCommentVNode("", true),
                              (_ctx.renderStore.isProjectActive(project.value))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[8] || (_cache[8] = _createTextVNode(" Selected ")),
                                    (_ctx.isFixedAmount)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "($" + _toDisplayString(_ctx.component.customData.fixedAmount) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(" Select ")
                                  ], 64))
                            ], 10, _hoisted_9))
                      ]),
                      _: 2
                    }, 1032, ["id", "showImage", "showDescription", "onRemoveProject"])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
        ], 2)
      ], 64))
}